// extracted by mini-css-extract-plugin
module.exports =  {"loader":"ru27up","loadAnimation":"yRApWv"};